import { useContext } from 'react';
import IdentityContext from '../../../../contexts/IdentityContext';
import { useTranslation } from 'react-i18next';

export default function UserMaterialContentType() {
  const { identity } = useContext(IdentityContext);

  const { t } = useTranslation();

  return (
    <>
      <i className="bc-icon bc-icon-account" />
      {identity.isTeacherAlike ? (
        <span>{t('MODULES.MATERIAL.COMPONENTS.MEDIALINK-MODALS.OPTIONS.CONTENTTYPE.OWN-MATERIAL')}</span>
      ) : (
        <span>{t('MODULES.MATERIAL.COMPONENTS.MEDIALINK-MODALS.OPTIONS.CONTENTTYPE.SHARED-MATERIAL')}</span>
      )}
    </>
  );
}
